<lib-page-layout>
  <lib-home-navbar
    pageHeader
    extended
    (onAddGameOpened)="goToGameCreator()"
    [isNewNotifications]="!!isNewNotifications()"></lib-home-navbar>

  <div pageHeader class="or-d-flex or-justify-content-evenly margin-top--54-px">
    <div
      (click)="goToList()"
      class="or-head-xl or-py-12-px or-px-8-px negative-margin-bottom-1-px"
      [ngClass]="!isMapActive ? 'or-color-white bottom-border-active' : 'or-color-secondary-2'">
      Lista
    </div>
    <div
      (click)="goToMap()"
      class="or-head-xl or-py-12-px or-px-8-px negative-margin-bottom-1-px"
      [ngClass]="isMapActive ? 'or-color-white bottom-border-active' : 'or-color-secondary-2'">
      Mapa
    </div>
  </div>

  <router-outlet></router-outlet>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
